export enum CoachListTab {
    NewAssignments = 0,
    DeclinedCs = 1,
    Approval = 2,
    PendingFollowUp = 3,
    OptedOut = 4,
    All = 5
}
